import React from 'react';

/**
 * Loading Spinner Component
 * 可重用的載入動畫組件，替代 "載入中..." 文字
 */

// 基礎 Spinner
export const Spinner = ({ size = '24px', color = '#667eea', borderWidth = '3px' }) => (
  <>
    <style>{`
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `}</style>
    <div
      style={{
        width: size,
        height: size,
        border: `${borderWidth} solid #f3f4f6`,
        borderTop: `${borderWidth} solid ${color}`,
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }}
    />
  </>
);

// 帶文字的 Spinner
export const SpinnerWithText = ({
  text = '載入中...',
  size = '24px',
  color = '#667eea',
  textColor = '#64748b',
  direction = 'vertical' // 'vertical' or 'horizontal'
}) => (
  <div style={{
    display: 'flex',
    flexDirection: direction === 'vertical' ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: direction === 'vertical' ? '12px' : '8px',
    padding: '20px'
  }}>
    <Spinner size={size} color={color} />
    <span style={{
      fontSize: 'var(--font-xxs)',
      color: textColor,
      fontWeight: '500'
    }}>
      {text}
    </span>
  </div>
);

// 全屏 Loading
export const FullScreenLoading = ({ text = '載入中...' }) => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255, 255, 255, 0.95)',
    zIndex: 9999
  }}>
    <Spinner size="48px" color="#667eea" borderWidth="4px" />
    <p style={{
      marginTop: '20px',
      fontSize: 'var(--font-xs)',
      color: '#64748b',
      fontWeight: '500'
    }}>
      {text}
    </p>
  </div>
);

// 卡片內 Loading
export const CardLoading = ({ text = '載入中...', minHeight = '200px' }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight,
    padding: '40px 20px'
  }}>
    <Spinner size="40px" color="#667eea" />
    <p style={{
      marginTop: '16px',
      fontSize: 'var(--font-xxs)',
      color: '#64748b',
      fontWeight: '500'
    }}>
      {text}
    </p>
  </div>
);

// 按鈕內 Loading（小型）
export const ButtonLoading = ({ color = '#ffffff' }) => (
  <Spinner size="16px" color={color} borderWidth="2px" />
);

// 行內 Loading（非常小型）
export const InlineLoading = ({ color = '#667eea' }) => (
  <Spinner size="14px" color={color} borderWidth="2px" />
);

export default {
  Spinner,
  WithText: SpinnerWithText,
  FullScreen: FullScreenLoading,
  Card: CardLoading,
  Button: ButtonLoading,
  Inline: InlineLoading
};
